import React , {Component} from 'react';
import AppUtils from '../../apputils';
import { ContactUs } from '../../models/users';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import ContactPage from './contact';
import ContactModal from './contactModal';


 class contact extends Component{
    constructor(){
        super();
        this.state={
            txtUserFullName:'',
            txtUserEmail:'',
            txtUserContact:'',
            txtUserMessage:'',
            sendData:false,
            isModalOpen:false
        }

        this.ContactData = {

        }
    }

    CloseModal = ()=>{
       
        this.setState({
            isModalOpen:false
        })
        this.HandleRouting('upcoming-events')
    }
    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }

    HandleContactInput = (e)=>{
        let val = e.target.value;
        let name = e.target.name;
        this.setState({ [name]: val });
    }

    SaveContactEntryData = (e)=>{

             this.ContactData = {
                 txtUserFullName:e.txtUserFullName,
                 txtUserEmail:e.txtUserEmail,
                 txtUserContact:e.txtUserContact,
                 txtUserMessage:e.txtUserMessage
             }


             this.setState({
                 sendData:true
             })

             console.log(this.ContactData);

    }

    HandleContactUsSuccessResponse = (res)=>{

         if(res !== false){
             console.log(res)

             this.setState({
                 sendData:false,
                 isModalOpen:true
             })
         }
         else{
             this.setState({
                 sendData:false
             })
         }

    }

    render(){
        return(
            <div>
            <ContactPage {...this.props}  mystate={this.state}
            HandleContactInput = {this.HandleContactInput}  SaveContactEntryData = {this.SaveContactEntryData}
            HandleRouting={this.HandleRouting}
           
           
            />
            <ContactModal {...this.props}  mystate={this.state}
            CloseModal={this.CloseModal}
            />
            {((this.state.sendData === true) ? ContactUs(this.props.PnkStore, this.ContactData, this.HandleContactUsSuccessResponse) : "")}
            </div>
        )
    }
}

export const Contact = PnkConnect(contact , '');